import styled, { css } from 'styled-components'

const sharedListStyles = css<{ $level: number }>`
  margin-left: ${({ $level }) => ($level === 1 ? 0 : '0.75rem')};
`

const bulletTypes = ['square', 'disc', 'circle']
export const BulletList = styled.ul<{ $level: number }>`
  ${sharedListStyles};
  list-style-type: ${({ $level }) => bulletTypes[$level % bulletTypes.length]};
`

const numberTypes = ['lower-roman', 'decimal', 'lower-alpha']
export const NumberedList = styled.ol<{ $level: number }>`
  ${sharedListStyles};
  list-style-type: ${({ $level }) => numberTypes[$level % numberTypes.length]};
`
